export default __webpack_public_path__ + "static/media/graph.31aa58ca.svg";